import { useNavigation, useTranslation } from '@helios/frontend-core';
import { PalmettoIcon } from '@palmetto/dsm-components';
import React from 'react';
import OutletIllustration from '../../assets/outlet.svg?react';
import { ROUTE } from '../../routes';
import { usePageError } from '../_app/PageErrorProvider';
import StatusMessageLayout from '../StatusMessageLayout/StatusMessageLayout';

export interface Props {
  onRetry?: () => void;
}

const PageError: React.FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation();
  const { openURL } = useNavigation();
  const { errorMessage } = usePageError();

  const handleGoHome = () => {
    openURL(ROUTE.ROOT);
  };

  return (
    <div className="fixed inset-0 md:static md:inset-auto flex items-center justify-center w-full h-full md:min-h-screen overflow-hidden px-8">
      <StatusMessageLayout
        trackingId="page-error"
        title={errorMessage || t('pageError.errorMessage')}
        illustration={
          <>
            <OutletIllustration />
            <div className="absolute inset-[0] opacity-70 bg-palmetto-500 mix-blend-hue"></div>
          </>
        }
        primaryCTA={{
          label: t('pageError.retry'),
          onClick: onRetry,
          emphasis: 'primary',
          size: 'small',
          leadingIcon: <PalmettoIcon name="refresh" />,
          layout: 'fill',
          trackingId: 'page-error-retry',
        }}
        secondaryCTA={{
          label: t('pageError.takeMeHome'),
          onClick: handleGoHome,
          emphasis: 'tertiary',
          size: 'small',
          leadingIcon: <PalmettoIcon name="home" />,
          layout: 'fill',
          trackingId: 'page-error-home',
        }}
      />
    </div>
  );
};

export default PageError;
